import { SegmentView } from "@tiny/api";
import { Tag } from "../../models/tags/Tag.types";
import { SegmentType, SortOption } from "./SegmentList.types";

export const sortOptions: SortOption[] = [
  { label: "Name", value: ["name,ASC"] },
  { label: "Number of Customers", value: ["numberOfCustomers,DESC"] },
  { label: "Modified Date", value: ["updatedAt,DESC"] },
  { label: "Created Date", value: ["createdAt,DESC"] },
];

export const itemsPerPageOptions = [5, 10, 15, 20];

export const pageableDefault = {
  page: 0,
  size: 5,
  sort: ["updatedAt,DESC"],
};

export const filtersTags: Tag[] = [
  {
    name: "Custom",
    id: "CUSTOM",
  },
  {
    name: "Predefined",
    id: "PREDEFINED",
  },
];

/**
 * Filter tags for callers that list every audience a contact can belong to, not just
 * custom segments — sources uploaded manually, pulled from an integration, or filled
 * by a form, alongside custom segments.
 */
export const allAudienceFiltersTags: Tag[] = [
  {
    name: "Manual",
    id: "UPLOAD",
  },
  {
    name: "Integration",
    id: "INTEGRATION",
  },
  {
    name: "Form",
    id: "FORM",
  },
  {
    name: "Custom",
    id: "CUSTOM",
  },
];

export const allAudienceSegmentTypes: SegmentType[] = [
  "UPLOAD",
  "INTEGRATION",
  "CUSTOM",
  "FORM",
];

export function getSegmentTypesByTags(
  tags: Tag[],
  defaultTypes: SegmentType[] = ["CUSTOM"]
) {
  const selectedTypes = tags.map((tag) => tag.id! as SegmentType);
  return tags.length > 0 ? selectedTypes : defaultTypes;
}

export function isPredefinedSegment(type: SegmentView["segmentType"]) {
  return (
    type === "PREDEFINED_RECOMMENDED" ||
    type === "PREDEFINED_LIBRARY" ||
    type === "PREDEFINED_DELIVERY"
  );
}

/**
 * Audiences that live under /main/audience/sources rather than /main/audience/segments.
 * A row of one of these types must not link into the segment editor.
 */
export function isSourceSegment(type: SegmentView["segmentType"]) {
  return type === "UPLOAD" || type === "INTEGRATION" || type === "FORM";
}
